import { Command } from 'commands/Commands';

export class ChangeContactButtonText extends Command {
  type: string = 'Member.ChangeContactButtonText';
  priority = 100;
  constructor(payload: string, id: string) {
    super(payload, id);
  }
}
